import { render, staticRenderFns } from "./VesselParticularsHM.vue?vue&type=template&id=b85b5474&scoped=true&"
import script from "./VesselParticularsHM.vue?vue&type=script&lang=js&"
export * from "./VesselParticularsHM.vue?vue&type=script&lang=js&"
import style0 from "./VesselParticularsHM.vue?vue&type=style&index=0&id=b85b5474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85b5474",
  null
  
)

export default component.exports